package com.hyperether.goodjob.models

import com.hyperether.goodjob.repository.remote.model.FileObject
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Job(
    @SerialName("_id") var id: String? = null,
    @SerialName("jobTitle") var jobTitle: String? = null,
    @SerialName("status") var status: String? = null,
    @SerialName("assignees") var assignees: Assignees? = null,
    @SerialName("creatorId") var creatorId: String? = null,
    @SerialName("workspaceId") var workspaceId: String? = null,
    @SerialName("start_at") var start_at: String? = null,
    @SerialName("end_at") var end_at: String? = null,
    @SerialName("repeat") var repeat: String? = null,
    @SerialName("dueDate") var dueDate: String? = null,
    @SerialName("startDate") var startDate: String? = null,
    @SerialName("jobDuration") var jobDuration: Long? = null,
    @SerialName("repeatInterval") var repeatInterval: List<String?>? = null,
    @SerialName("steps") var steps: List<Step>? = null,
    @SerialName("userId") var userId: String? = null,
    @SerialName("contactSiteId") var contactSiteId: String? = null,
    @SerialName("contactSiteName") var contactSiteName: String? = null,
    @SerialName("contactParentId") var contactParentId: String? = null,
    @SerialName("createdAt") var createdAt: Long? = null,
    @SerialName("updatedAt") var updatedAt: Long? = null,
    @SerialName("notes") var notes: String? = null,
    @SerialName("fileObjects") var fileObjects: List<FileObject?>? = null,
    @SerialName("completionReport") var completionReport: String? = null,
    @SerialName("noteObjects") var noteObjects: List<Note>? = null
) {
    fun isJobDifferent(remoteJob: Job): Boolean {
        val differences = mutableListOf<String>()

        if (this.jobTitle != remoteJob.jobTitle) differences.add("jobTitle: '${this.jobTitle}' vs '${remoteJob.jobTitle}'")
        if (this.status != remoteJob.status) differences.add("status: '${this.status}' vs '${remoteJob.status}'")
        if (this.assignees?.isDifferent(remoteJob.assignees) == true) differences.add("assignees: '${this.assignees}' vs '${remoteJob.assignees}'")
        if (this.creatorId != remoteJob.creatorId) differences.add("creatorId: '${this.creatorId}' vs '${remoteJob.creatorId}'")
        if (this.workspaceId != remoteJob.workspaceId) differences.add("workspaceId: '${this.workspaceId}' vs '${remoteJob.workspaceId}'")
        if (this.start_at != remoteJob.start_at) differences.add("start_at: '${this.start_at}' vs '${remoteJob.start_at}'")
        if (this.end_at != remoteJob.end_at) differences.add("end_at: '${this.end_at}' vs '${remoteJob.end_at}'")
        if (this.repeat != remoteJob.repeat) differences.add("repeat: '${this.repeat}' vs '${remoteJob.repeat}'")
        if (this.dueDate != remoteJob.dueDate) differences.add("dueDate: '${this.dueDate}' vs '${remoteJob.dueDate}'")
        if (this.startDate != remoteJob.startDate) differences.add("startDate: '${this.startDate}' vs '${remoteJob.startDate}'")
        if (this.jobDuration != remoteJob.jobDuration) differences.add("jobDuration: '${this.jobDuration}' vs '${remoteJob.jobDuration}'")
        if (this.repeatInterval != remoteJob.repeatInterval) differences.add("repeatInterval: '${this.repeatInterval}' vs '${remoteJob.repeatInterval}'")

        // Compare steps lists by comparing each element
        val stepsChanged = when {
            this.steps == null && remoteJob.steps != null -> true
            this.steps != null && remoteJob.steps == null -> true
            this.steps?.size != remoteJob.steps?.size -> true
            else -> {
                this.steps?.zip(remoteJob.steps ?: emptyList())?.any { (thisStep, otherStep) ->
                    thisStep.isDifferent(otherStep)
                } ?: false
            }
        }

        if (stepsChanged) differences.add("steps: different elements found")

        if (this.contactSiteId != remoteJob.contactSiteId) differences.add("contactSiteId: '${this.contactSiteId}' vs '${remoteJob.contactSiteId}'")
        if (this.contactSiteName != remoteJob.contactSiteName) differences.add("contactSiteName: '${this.contactSiteName}' vs '${remoteJob.contactSiteName}'")
        if (this.contactParentId != remoteJob.contactParentId) differences.add("contactParentId: '${this.contactParentId}' vs '${remoteJob.contactParentId}'")
//        if (this.notes != remoteJob.notes) differences.add("notes: '${this.notes}' vs '${remoteJob.notes}'")
        if (this.fileObjects != remoteJob.fileObjects) differences.add("fileObjects: '${this.fileObjects}' vs '${remoteJob.fileObjects}'")
        if (this.noteObjects != remoteJob.noteObjects) differences.add("noteObjects: '${this.noteObjects}' vs '${remoteJob.noteObjects}'")
//        if (this.updatedAt != remoteJob.updatedAt) differences.add("updatedAt: '${this.updatedAt}' vs '${remoteJob.updatedAt}'")

        if (differences.isNotEmpty()) {
            println("Job differences found for job '${this.jobTitle}' (${this.id}):")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}